import { Platform } from '@angular/cdk/platform';
import { Injectable, inject, signal } from '@angular/core';
import { BROWSER_WINDOW } from 'app/tokens/browser.tokens';

type BeforeInstallPromptEvent = Event & {
  prompt(): Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
};

@Injectable({
  providedIn: 'root',
})
export class PwaService {
  private readonly platform = inject(Platform);
  private readonly browserWindow = inject(BROWSER_WINDOW);
  private readonly canInstallState = signal(false);
  private initialized = false;

  private promptEvent: BeforeInstallPromptEvent | null = null;
  readonly isIOS = this.platform.IOS;
  readonly canInstall = this.canInstallState.asReadonly();

  initPwaPrompt(): void {
    const browserWindow = this.browserWindow;

    if (this.initialized || this.isIOS || !browserWindow) {
      return;
    }

    this.initialized = true;
    browserWindow.addEventListener('beforeinstallprompt', (event: Event) => {
      const promptEvent = event as BeforeInstallPromptEvent;
      promptEvent.preventDefault();
      this.promptEvent = promptEvent;
      this.canInstallState.set(true);
    });
  }

  installPwa(): void {
    if (this.promptEvent) {
      void this.promptEvent.prompt();
      void this.promptEvent.userChoice.then(() => {
        this.canInstallState.set(false);
        this.promptEvent = null;
      });
    }
  }
}
